import React from "react";

export const CanvasRevealEffect = (props: any) => {
  // Placeholder for the real effect
  return null;
}; 